import {IconButton} from 'platform/components';
import {HStack} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {CustomNoticeListItem} from '@dms/api/core';

import {parseDate, suffixTestId, TestIdProps} from 'shared/web';

import {CustomNoticeCardBase} from '../CustomNoticeCardBase/CustomNoticeCardBase';

interface CustomNoticeCardProps extends TestIdProps {
  notice: CustomNoticeListItem;
  onEdit: () => void;
  onDelete: () => void;
}

export function CustomNoticeCard(props: CustomNoticeCardProps) {
  const dateTimeFormatter = useDateTimeFormatter();

  const lastChangedAt = dateTimeFormatter(
    'dateShort',
    parseDate(props.notice.updatedAt ?? props.notice.createdAt)
  );

  return (
    <CustomNoticeCardBase
      notice={props.notice}
      parameters={[lastChangedAt]}
      actions={
        <HStack spacing={2}>
          <IconButton
            icon="action/delete"
            severity="danger"
            size="small"
            isDisabled={props.notice.canDelete !== true}
            onClick={props.onDelete}
            data-testid={suffixTestId('customNoticeCard-delete', props)}
          />
          <IconButton
            icon="content/create"
            size="small"
            isDisabled={props.notice.canUpdate !== true}
            onClick={props.onEdit}
            data-testid={suffixTestId('customNoticeCard-edit', props)}
          />
        </HStack>
      }
      data-testid={props['data-testid']}
    />
  );
}
